import { Store } from '@ngrx/store';
import { FirebaseOptions } from 'firebase/app';

import { Inject, Injectable } from '@angular/core';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';

import { of } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  filter,
  map,
  switchMap,
} from 'rxjs/operators';

import { MwUserService } from '../../services/user.service';
import * as actions from './user.actions';

@Injectable()
export class MwUserEffectsService {
  constructor(
    private readonly fireMessaging: AngularFireMessaging,
    private readonly store: Store<any>,
    private readonly userService: MwUserService,
    @Inject(FIREBASE_OPTIONS) private readonly firebaseOptions: FirebaseOptions
  ) {}

  registerFcmToken(): void {
    this.userService.userProfile$
      .pipe(
        map((t) => t?.userId),
        filter(
          (userId) =>
            userId !== undefined && userId > 0 && !!this.firebaseOptions.apiKey
        ),
        distinctUntilChanged(),
        switchMap(() => this.fireMessaging.requestToken),
        filter((token) => !!token),
        catchError((err) => {
          console.error(err);
          return of(null);
        })
      )
      .subscribe((token) => {
        if (token) {
          this.store.dispatch(actions.registerFcmToken({ token }));
        }
      });
  }
}
